// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"common":"d3ed226c5ebc3c59","src_app_features_ncp_ncp_module_ts":"a95d7f645f40657c","src_app_features_cp_cp_module_ts":"88bb6a9f86ab0877"}[chunkId] + ".js";
};